var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiarrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.812,
    height: 16.444,
    viewBox: "0 0 15.812 16.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(-256.5 -1790.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_22",
    "data-name": "Polygon 22",
    d: "M7.906,0l7.906,13.915H0Z",
    transform: "translate(272.312 1790.5) rotate(90)",
    fill: "#57bedf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_22_-_Outline",
    "data-name": "Polygon 22 - Outline",
    d: "M7.906,2.024,1.718,12.915H14.094L7.906,2.024M7.906,0l7.906,13.915H0Z",
    transform: "translate(272.312 1790.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_21",
    "data-name": "Polygon 21",
    d: "M7.906,0l7.906,13.915H0Z",
    transform: "translate(270.415 1791.132) rotate(90)",
    fill: "#da3981"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiarrow);
export default __webpack_public_path__ + "static/media/liarrow.1e548b8ebb671ff3c4b3bf719f037c5e.svg";
export { ForwardRef as ReactComponent };